export default {
  BASE_URL: '/sys/module',
  api: [
    {
      name: 'list',
      desc: '获取模块列表',
      method: 'GET',
      path: 'list/{code}'
    },
    {
      name: 'insert',
      desc: '新增模块',
      method: 'POST',
      path: 'add'
    },
    {
      name: 'update',
      desc: '编辑模块',
      method: 'PUT',
      path: 'update'
    },
    {
      name: 'toggleStatus',
      desc: '启用/禁用模块',
      method: 'PUT',
      path: 'isEnable'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/api/system/module/index.js